import React, { useState } from "react";

import ecom1 from "../../assets/_iws_e_commerce_1.webp";
import ecom2 from "../../assets/_iws_e_commerce_2.webp";
import ecom3 from "../../assets/_iws_e_commerce_3.webp";

import processed1 from "../../assets/_iws_fresh_processed_foods_1.webp";
import processed2 from "../../assets/_iws_fresh_processed_foods_2.webp";
import processed3 from "../../assets/_iws_fresh_processed_foods_3.webp";

import electro1 from "../../assets/_iws_electronics_gadgets_1.webp";
import electro2 from "../../assets/_iws_electronics_gadgets_2.webp";
import electro3 from "../../assets/_iws_electronics_gadgets_3.webp";

import fmcg1 from "../../assets/_iws_fmcg_1.webp";
import fmcg2 from "../../assets/_iws_fmcg_2.webp";
import fmcg3 from "../../assets/_iws_fmcg_3.webp";

import const1 from "../../assets/_iws_construction_supplies_1.webp";
import const2 from "../../assets/_iws_construction_supplies_2.webp";
import const3 from "../../assets/_iws_construction_supplies_3.webp";

import furni1 from "../../assets/_iws_furniture_1.webp";
import furni2 from "../../assets/_iws_furniture_2.webp";
import furni3 from "../../assets/_iws_furniture_3.webp";

import pharma1 from "../../assets/_iws_pharma_cemicals_1.webp";
import pharma2 from "../../assets/_iws_pharma_cemicals_2.webp";
import pharma3 from "../../assets/_iws_pharma_cemicals_3.webp";

import log1 from "../../assets/_iws_logistics_1.webp";
import log2 from "../../assets/_iws_logistics_2.webp";
import log3 from "../../assets/_iws_logistics_3.webp";

import Grid from "../../assets/Grid.png";

const industriesData = [
  {
    name: "E-COMMERCE BRANDS",
    content: "We streamline e-commerce logistics from warehouse to doorstep.",
    images: [ecom1, ecom2, ecom3],
  },
  {
    name: "FRESH & PROCESSED FOODS",
    content: "Temperature-controlled and timely food deliveries ensured.",
    images: [processed1, processed2, processed3],
  },
  {
    name: "ELECTRONICS & GADGETS",
    content: `From smartphones and laptops to home appliances and accessories, we help manufacturers, distributors, and retailers deliver high-value, fragile electronic goods with care. Our logistics solutions ensure anti-shock handling, secure packaging compatibility, and timely deliveries across urban and semi-urban markets. Whether it's single-unit last-mile delivery or bulk movement between warehouses, Packky (powered by Chaafo) ensures safety and efficiency.`,
    images: [electro1, electro2, electro3],
  },
  {
    name: "FMCG GOODS",
    content: "Fast-moving consumer goods, delivered rapidly and reliably.",
    images: [fmcg1, fmcg2, fmcg3],
  },
  {
    name: "CONSTRUCTION SUPPLIES",
    content: "Heavy-load materials delivered to the right site at the right time.",
    images: [const1, const2, const3],
  },
  {
    name: "FURNITURES",
    content: "Bulky and delicate items handled with care in every delivery.",
    images: [furni1, furni2, furni3],
  },
  {
    name: "PHARMA & CHEMICALS",
    content: "Secure and temperature-sensitive pharma deliveries managed.",
    images: [pharma1, pharma2, pharma3],
  },
  {
    name: "LOGISTICS",
    content: "Full-suite logistics solutions for various business sizes.",
    images: [log1, log2, log3],
  },
];

const IndustriesWeServe = () => {
  const [selected, setSelected] = useState("ELECTRONICS & GADGETS");

  const selectedIndustry = industriesData.find(
    (industry) => industry.name === selected
  );

return (
  <div   className="w-full overflow-x-hidden bg-cover bg-center bg-repeat py-10 md:py-12"
  style={{
    backgroundImage: `url(${Grid})`,
    backgroundSize: "1200px",
    backgroundPosition: "center",
    minHeight: "100%",
  }}>
    <div

>
      <div className="mx-auto w-full max-w-7xl px-4">
        
        {/* Header */}
        <div className="mb-8 text-center">
          <h2 className="text-[22px] font-semibold text-[#212529] md:text-[28px]">
            Industries We Serve
          </h2>

          <p className="mx-auto mt-2 max-w-[370px] text-[14px] leading-6 lg:text-[20px] font-medium text-gray-600 sm:max-w-[600px] sm:text-[16px]">
            Serving diverse industries with fast, reliable, and scalable delivery.
          </p>
        </div>

      
       {/* Category Tabs */}
<div
  className="relative left-1/2 mb-12 w-screen -translate-x-1/2 px-4 pb-3"
  style={{
    overflowX: "scroll",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  }}
>
  <div
    className="flex min-w-max justify-center gap-3 text-[#212529]"
    style={{
      WebkitOverflowScrolling: "touch",
    }}
  >
    {industriesData.map((industry, idx) => (
      <button
        key={idx}
        onClick={() => setSelected(industry.name)}
        className={`shrink-0 whitespace-nowrap rounded-lg px-6 py-4 text-[13px] font-medium transition-all sm:text-sm ${
          selected === industry.name
            ? "btnn-gradiant text-white"
            : "bg-gray-100 text-gray-600 hover:bg-gray-200"
        }`}
      >
        {industry.name}
      </button>
    ))}
  </div>
</div>

        {/* Content */}
        <div className="mx-auto flex w-full max-w-[430px] flex-col gap-4 md:max-w-none md:flex-row md:items-start md:justify-between lg:ml-24">
          
          {/* Left Images */}
          <div className="flex w-full flex-col gap-4 md:w-[48%]">
            <img
              src={selectedIndustry.images[0]}
              alt="Industry visual"
              className="h-[132px] w-full rounded-md object-cover sm:h-[220px] md:h-[180px] md:w-[90%]"
            />

            <div className="grid grid-cols-2 gap-4 md:flex md:gap-3">
              {[1, 2].map((i) => (
                <img
                  key={i}
                  src={selectedIndustry.images[i]}
                  alt="Industry visual"
                  className="h-[130px] w-full rounded-md object-cover sm:h-[160px] md:h-[180px] md:w-[44%]"
                />
              ))}
            </div>
          </div>

          {/* Right Description */}
          <div className="w-full text-[#212529] md:w-[48%] lg:!w-[650px]">
            <div className="rounded-2xl bg-white/90 p-6 shadow-sm md:min-h-[250px]">
              <h5 className="mb-3 text-[20px] font-bold uppercase">
                {selectedIndustry.name}
              </h5>

              <p className="text-[16px] leading-7 text-black">
                {selectedIndustry.content}
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
);
};

export default IndustriesWeServe;
